import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Events from "core-web/libs/Events";
import { PageEvents, ProductEvents } from "core-web/libs/Events/constants";
import { injectModels } from "core-web/state";
import getCurrentPathname from "core-web/state/models/Application/utils/getCurrentPathname";
import resolveSearchPage from "core-web/state/models/Page/dispatches/resolveSearch";
import resolveSlug from "core-web/state/models/Page/dispatches/resolveSlug";
import getCurrentSearch from "core-web/state/models/Page/utils/getCurrentSearch";
import queryDefault from "core-web/state/models/Search/dispatches/queryDefault";
import Meta from "core-web/components/Meta";
import { inServer } from "core-web/constants";
import views from "core-web/views";
import ViewsLoading from "theme/views/ViewsLoading";

class RouteResolver extends Component {
    static propTypes = {
        application: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        page: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        const { application, page } = props;

        queryDefault(props.location);

        Events.subscribe("reload", () => {
            this.resolve();
        });

        if (!inServer && page.data) {
            Events.trigger(PageEvents.RESET);
            Events.trigger(PageEvents.VIEW, { application, page });

            if (page.type === "product") {
                Events.trigger(ProductEvents.VIEW, { data: page.data.product });
            }
        }
    }

    componentDidMount() {
        const { page } = this.props;

        if (!page.data) {
            this.resolve();
        }

        this.lastPageRender = null;
    }

    shouldComponentUpdate(nextProps) {
        const { page, location } = this.props;

        if (page.isFetching && !nextProps.page.isFetching) {
            return true;
        }

        if (location.pathname !== nextProps.location.pathname) {
            this.resolve(nextProps.location);
        } else if (location.search !== nextProps.location.search) {
            this.resolveSearch();
        }

        return false;
    }

    resolve = (location = this.props.location) => {
        const currentPathname = getCurrentPathname();
        resolveSlug(
            currentPathname,
            location,
            null,
            null,
            this.props.application.locale,
            this.props.application.path,
            this.props.application.origin,
        );
    };

    resolveSearch = () => {
        const search = getCurrentSearch();
        resolveSearchPage(search);
    };

    render() {
        const { page, history } = this.props;
        const NotFound = views.page?.templates?.not_found || null;
        // Default page = Not Found.
        let PageRenderer = NotFound;

        // If we are loading and have an old page to show.
        if (page.isFetching && this.lastPageRender) {
            PageRenderer = this.lastPageRender;
            // If we do not have a page.type and we are not loading, we should show NotFound.
        } else if (page.isFetching || page.isFetching === null) {
            PageRenderer = ViewsLoading;
        }

        if (page.isFetching === false && page.type) {
            if (!inServer && page.type === "redirect" && page.data.to) {
                history.replace(page.data.to);
                return null;
            }
            // Check if this page has a template set.
            if (page.template && views[page.type] && views[page.type].templates) {
                // Check if the template we're after is defined.
                if (views[page.type].templates[page.template]) {
                    PageRenderer = views[page.type].templates[page.template];
                    this.lastPageRender = PageRenderer;
                } else {
                    console.error(`The template ${page.template} for page type ${page.type} was not found.`);
                }
            } else {
                PageRenderer = page.type && views[page.type];
                this.lastPageRender = PageRenderer;
            }
        } else if (page.isFetching === false && !page.type) {
            // if last page was 404 set as last page
            this.lastPageRender = PageRenderer;
        }

        return (
            <Fragment>
                <Meta layout="page" />
                <PageRenderer data={page.data} />
            </Fragment>
        );
    }
}

export default withRouter(injectModels(["application", "page"])(RouteResolver));
